import styled from '@emotion/styled';
import { Skeleton as MUISkeleton } from '@mui/material';

const Skeleton = styled(MUISkeleton)`
  transform: none;
  margin-bottom: .5rem;
`;

export default Skeleton;
